// Invoices.styles.js
export const invoicesStyles = {
  btnNew: {
    btn: {
      marginLeft: 'auto',
      marginRight: '8px',
      marginBottom: '20px'
    }
  },
  breadcrumb: {
    margin: '16px 0'
  },
  pageTitle: {
    marginRight: 'auto',
    width: '100%'
  },
  btn: {
    padding: '0 5px'
  },
  paid: {
    backgroundColor: '#52c41a'
  },
  noPaid: {
    backgroundColor: '#d9d9d9',
    color: 'gray'
  }
}
